import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

import { useLocalizationContext } from '@sharesight/gatsby-plugin-sharesight-localization';

import { useCookiePreferences } from 'components/CookiePreferences/CookiePreferencesProvider';

import { COOKIE_COUNTRY } from './constants';

import type { FC } from 'react';

/**
 * This sets a sharesight_country cookie if functionality cookies are allowed
 * This is strictly a component with a side-effect and does not render anything.
 */
export const SharesightCountryCookie: FC = () => {
  const cookiePreferences = useCookiePreferences();

  const { currentLocale } = useLocalizationContext();

  const [_cookie, setCookie] = useCookies([COOKIE_COUNTRY]);

  useEffect(() => {
    if (cookiePreferences?.functionality) {
      setCookie(COOKIE_COUNTRY, currentLocale.id, { path: '/' });
    }
  }, [setCookie, cookiePreferences?.functionality, currentLocale.id]);

  return null;
};
